import React, {FC} from 'react';
import styled from 'styled-components';

import {Trans} from '../../../../../../libs/shared/core/src/helpers/internationalization/react';
import {OkLearnMoreDialog} from '../../../../../../libs/shared/ui/src/components/dialogs/okLearnMoreDialog';
import {Icon} from '../../../../../../libs/shared/ui/src/components/icon/icon';
import {useUserTheme} from '../../../../../../libs/shared/ui/src/theme/userThemeProvider';
import {openInBrowser} from '../../../../../../srcCommon/browser/openInBrowser';
import {
  learnMoreErrorUrl,
  LinkedConversationsError,
} from '../../../../../helpers/models/linkedConversationsHelpers';

/*
 * Props.
 */

interface LinkConversationsErrorDialogProps {
  onClose: () => void;
  linkConversationError: LinkedConversationsError;
}

/*
 * Styles.
 */

const StyledOkLearnMoreDialog = styled(OkLearnMoreDialog)`
  margin: 0 16px;
`;

/*
 * Component.
 */

export const LinkConversationsErrorDialog: FC<LinkConversationsErrorDialogProps> = (props) => {
  const {onClose} = props;
  const theme = useUserTheme();

  const onLearnMoreClick = () => {
    openInBrowser(learnMoreErrorUrl);
  };

  return (
    <StyledOkLearnMoreDialog
      title={<Trans id="link-conversations-error-title">Cannot link conversations</Trans>}
      titleIcon={<Icon name="warningFilledTriangle" color={theme.palette.red.shade40} size={16} />}
      onRequestClose={onClose}
      onLearnMoreClick={onLearnMoreClick}
    >
      {props.linkConversationError.message}
    </StyledOkLearnMoreDialog>
  );
};
